import React, {
  useState,
  useMemo,
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../atom/ModalAtom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { userIdState } from '../atom/TokenAtom';
import { WorkNumDto } from '../model/room.dto';
import { roomAPI } from '../api/axiosIndex';
import { refreshDataStateRecoil } from '../atom/CommonAtom';
import eventbus from '../api/eventbus';

interface WorkNumProps {
  listId: number;
  type: string;
}

const WorkNum = ({ listId, type }: WorkNumProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);

  const [workNums, setWorkNums] = useState<WorkNumDto | null>(null);

  // 탕수 조회
  const getWorkNums = async () => {
    try {
      const response = await roomAPI.getWorkNums(listId);
      setWorkNums(response.data[0]);
    } catch (err: any) {
      setError('탕수 조회에 실패하였습니다.');
    }
  };

  // 탕수 조회 useEffect
  useEffect(() => {
    getWorkNums();
  }, []);

  // 입출차 이벤트 처리
  useEffect(() => {
    eventbus.on('entry', () => {
      getWorkNums();
    });
  }, []);

  return (
    <>
      {type === 'today'
        ? workNums?.todayCycle
        : type === 'month'
          ? workNums?.monthCycle
          : (workNums?.monthCycle ?? 0) + (workNums?.monthAddition ?? 0)}
    </>
  );
};

export default WorkNum;
